// 将oss数据转换成就数据，减少重构工作量，而且旧数据格式更方便用更少的判断，做更多事。
export function transFormBookDataFromNewToOld(ossBookJSON) {
  // 增加所有页和最大页数
  const allPages = ossBookJSON.chapters.map((i) => i.pages).flat()
  // 用数组索引，重建pageNo
  ossBookJSON.allPages = allPages.map((item, index) => {
    item.oldPageNo = item.pageNo
    item.pageNo = index + 1
    return item
  })
  ossBookJSON.maxPageNo = Math.max.apply(
    null,
    allPages.map((i) => i.pageNo)
  )
  // 赋予数据章和页的上下属性,减少重构修改
  ossBookJSON.chapters.forEach((item, chapterIndex) => {
    const lastIndex = ossBookJSON.chapters.length - 1
    const preChapterId = chapterIndex === 0 ? null : ossBookJSON.chapters[chapterIndex - 1].id
    const nextChapterId =
      chapterIndex === lastIndex ? null : ossBookJSON.chapters[chapterIndex + 1].id
    item.pages.forEach((page, pageIndex) => {
      const prePageId = (ossBookJSON.allPages.find((i) => i.pageNo === page.pageNo - 1) || {}).id
      const nextPageId = (ossBookJSON.allPages.find((i) => i.pageNo === page.pageNo + 1) || {}).id
      const isFirst = pageIndex === 0
      const isLast = pageIndex === item.pages.length - 1
      page.oldData = {
        // 分类
        category: ossBookJSON.category,
        pageId: page.id,
        chapterId: item.id,
        // 最大页数
        maxPageNo: ossBookJSON.maxPageNo,
        // 当前页数
        currentPageNo: page.pageNo,
        // 重建pageNo
        pageNo: page.pageNo,
        // 上一章
        preChapterId: isFirst ? preChapterId : item.id,
        // 下一章
        nextChapterId: isLast ? nextChapterId : item.id,
        // 上一页
        prePageId,
        // 下一页
        nextPageId
      }
    })
  })
  return ossBookJSON
}
